/**
 * Standalone "a registry item was created" signal.
 *
 * Kept free of Catalog-barrel imports so non-Catalog modules (e.g. the admin
 * EditGift dialog) can emit into it without creating a circular import: the
 * Catalog barrel pulls in `Catalog.provider`, which imports `EditGiftDialog`.
 */
import type { RegistryItemFragment } from '@graphql/fragments/registry.graphql.generated';
import { Subject } from 'rxjs';
import type { AddCatalogItemPurchaseMethod } from './components/ProductDetails/components/BuyForm/BuyForm.types';

type CreateRegistryItemSubject = {
  purchaseMethod?: AddCatalogItemPurchaseMethod | null;
  item: RegistryItemFragment;
};

export const createRegistryItemSubject = new Subject<CreateRegistryItemSubject>();
